import { createContext } from 'react';

export interface GlobalContextProps {
  featureFlags: Record<string, boolean>;
}
export const GlobalContext = createContext<GlobalContextProps>({
  featureFlags: {},
});

export { ConfigProvider, useAppConfig } from './ConfigProvider';
